const common = {
    en: {
        "nav.dashboard": "Dashboard",
        "nav.users": "Users",
        "nav.booking": "Booking",
        "nav.cars": "Cars",
        "nav.containers": "Containers",
        "nav.boats": "Boats",
        "nav.calculator": "Calculator",
        "nav.transactions": "Transactions",
        "nav.ticket": "Ticket",
        "nav.news": "News",
        "nav.balanceRequests": "Balance requests",
        "nav.financing": "Financing",
        "nav.earnings": "Earnings & Payroll",
        "nav.bankReconcile": "Bank reconciliation",
        "nav.broadcast": "Broadcast",
        "nav.chat": "Chat",
        "nav.surveys": "Surveys",
        "nav.messaging": "Notifications & templates",
        "nav.activityLog": "Activity log",
        "nav.reports": "Reports & backup",
        "nav.calcCategories": "Price categories",
        "nav.customsCalc": "Customs calculator",
        "nav.integrations": "Integrations",
        "nav.settings": "Settings & dictionaries",
        "nav.permissions": "Permissions",
        "nav.changePassword": "Change Password",
        "nav.logout": "Log Out",
        "nav.menu": "Menu",
        "nav.account": "Account",

        "common.addNew": "Add New",
        "common.export": "Export",
        "common.filters": "Filters",
        "common.search": "Search",
        "common.edit": "Edit",
        "common.delete": "Delete",
        "common.view": "View",
        "common.save": "Save Changes",
        "common.cancel": "Cancel",
        "common.close": "Close",
        "common.yes": "Yes",
        "common.no": "No",
        "common.submit": "Submit",
        "common.confirm": "Confirm",
        "common.selectDate": "Select Date",
        "common.startDate": "Start Date",
        "common.endDate": "End Date",
        "common.confirmDate": "Confirm Date",
        "common.clearDate": "Clear Date",
        "common.sortBy": "Sort By",
        "common.actions": "Actions",
        "common.download": "Download",

        "table.showing": "Showing",
        "table.of": "of",
        "table.total": "Total",
        "table.show": "Show",
        "table.notFound": "Records not found",
        "table.noData": "No Data",
        "table.notDefined": "Not defined",

        "view.table": "Table view",
        "view.grid": "Grid view",
        "view.list": "List view",

        "header.searchByVin": "Search By VIN",

        "status.not_defined": "Not defined",
        "status.warehouse": "Warehouse",
        "status.picked_up": "Picked up",
        "status.loaded": "Loaded",
        "status.arrived": "Arrived",
        "status.opened": "Opened",
    },
    ru: {
        "nav.dashboard": "Панель",
        "nav.users": "Пользователи",
        "nav.booking": "Бронирование",
        "nav.cars": "Автомобили",
        "nav.containers": "Контейнеры",
        "nav.boats": "Суда",
        "nav.calculator": "Калькулятор",
        "nav.transactions": "Транзакции",
        "nav.balanceRequests": "Запросы баланса",
        "nav.financing": "Финансирование",
        "nav.earnings": "Доходы и зарплаты",
        "nav.bankReconcile": "Сверка с банком",
        "nav.broadcast": "Рассылка",
        "nav.chat": "Чат",
        "nav.surveys": "Опросы",
        "nav.messaging": "Уведомления и шаблоны",
        "nav.activityLog": "Журнал действий",
        "nav.reports": "Отчёты и бэкап",
        "nav.calcCategories": "Ценовые категории",
        "nav.customsCalc": "Калькулятор растаможки",
        "nav.integrations": "Интеграции",
        "nav.settings": "Настройки и справочники",
        "nav.permissions": "Права доступа",
        "nav.ticket": "Тикеты",
        "nav.news": "Новости",
        "nav.changePassword": "Смена пароля",
        "nav.logout": "Выход",
        "nav.menu": "Меню",
        "nav.account": "Аккаунт",

        "common.addNew": "Добавить",
        "common.export": "Экспорт",
        "common.filters": "Фильтры",
        "common.search": "Поиск",
        "common.edit": "Редактировать",
        "common.delete": "Удалить",
        "common.view": "Просмотр",
        "common.save": "Сохранить",
        "common.cancel": "Отмена",
        "common.close": "Закрыть",
        "common.yes": "Да",
        "common.no": "Нет",
        "common.submit": "Отправить",
        "common.confirm": "Подтвердить",
        "common.selectDate": "Выбрать дату",
        "common.startDate": "Дата начала",
        "common.endDate": "Дата окончания",
        "common.confirmDate": "Подтвердить дату",
        "common.clearDate": "Очистить дату",
        "common.sortBy": "Сортировать",
        "common.actions": "Действия",
        "common.download": "Скачать",

        "table.showing": "Показано",
        "table.of": "из",
        "table.total": "Всего",
        "table.show": "Показать",
        "table.notFound": "Записи не найдены",
        "table.noData": "Нет данных",
        "table.notDefined": "Не определено",

        "view.table": "Таблица",
        "view.grid": "Сетка",
        "view.list": "Список",

        "header.searchByVin": "Поиск по VIN",

        "status.not_defined": "Не определено",
        "status.warehouse": "Склад",
        "status.picked_up": "Забрано",
        "status.loaded": "Загружено",
        "status.arrived": "Прибыло",
        "status.opened": "Открыто",
    },
    geo: {
        "nav.dashboard": "მთავარი",
        "nav.users": "მომხმარებლები",
        "nav.booking": "ჯავშანი",
        "nav.cars": "ავტომობილები",
        "nav.containers": "კონტეინერები",
        "nav.boats": "გემები",
        "nav.calculator": "კალკულატორი",
        "nav.transactions": "ტრანზაქციები",
        "nav.balanceRequests": "ბალანსის მოთხოვნები",
        "nav.financing": "დაფინანსება",
        "nav.earnings": "შემოსავლები/ხელფასი",
        "nav.bankReconcile": "ბანკის შედარება",
        "nav.broadcast": "მასობრივი შეტყობინება",
        "nav.chat": "ჩატი",
        "nav.surveys": "გამოკითხვები",
        "nav.messaging": "შეტყობინებები/შაბლონები",
        "nav.activityLog": "აქტივობის ჟურნალი",
        "nav.reports": "რეპორტები/ასლი",
        "nav.calcCategories": "ფასის კატეგორიები",
        "nav.customsCalc": "განბაჟების კალკულატორი",
        "nav.integrations": "ინტეგრაციები",
        "nav.settings": "პარამეტრები/ლექსიკონები",
        "nav.permissions": "უფლებები",
        "nav.ticket": "ტიკეტები",
        "nav.news": "სიახლეები",
        "nav.changePassword": "პაროლის შეცვლა",
        "nav.logout": "გასვლა",
        "nav.menu": "მენიუ",
        "nav.account": "ანგარიში",

        "common.addNew": "დამატება",
        "common.export": "ექსპორტი",
        "common.filters": "ფილტრები",
        "common.search": "ძებნა",
        "common.edit": "რედაქტირება",
        "common.delete": "წაშლა",
        "common.view": "ნახვა",
        "common.save": "შენახვა",
        "common.cancel": "გაუქმება",
        "common.close": "დახურვა",
        "common.yes": "დიახ",
        "common.no": "არა",
        "common.submit": "გაგზავნა",
        "common.confirm": "დადასტურება",
        "common.selectDate": "თარიღის არჩევა",
        "common.startDate": "დაწყების თარიღი",
        "common.endDate": "დასრულების თარიღი",
        "common.confirmDate": "თარიღის დადასტურება",
        "common.clearDate": "თარიღის გასუფთავება",
        "common.sortBy": "დალაგება",
        "common.actions": "მოქმედებები",
        "common.download": "ჩამოტვირთვა",

        "table.showing": "ნაჩვენებია",
        "table.of": "დან",
        "table.total": "სულ",
        "table.show": "აჩვენე",
        "table.notFound": "ჩანაწერები ვერ მოიძებნა",
        "table.noData": "მონაცემები არ არის",
        "table.notDefined": "არ არის განსაზღვრული",

        "view.table": "ცხრილის ხედი",
        "view.grid": "ბადის ხედი",
        "view.list": "სიის ხედი",

        "header.searchByVin": "ძებნა VIN-ით",

        "status.not_defined": "არ არის განსაზღვრული",
        "status.warehouse": "საწყობი",
        "status.picked_up": "აყვანილი",
        "status.loaded": "დატვირთული",
        "status.arrived": "ჩამოსული",
        "status.opened": "გახსნილი",
    },
};

export default common;
